import React, {Fragment} from 'react';
import Select from '../../form/Select';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";

class CommissionForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-5">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="commissioner"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Partner"
                        />
                    </div>
                    <div className="col-sm-5">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="business_service_provider"
                            values={this.props.values}
                            value={this.props.values.business_service_provider || this.props.pos.partner.partner_id}
                            setFieldValue={this.props.setFieldValue}
                            label="Szolgátató"
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <Select
                            objectValue={false}
                            name="provider"
                            optionname="CommissionProvider"
                            storeType="local"
                            value={this.props.values.provider}
                            label="Típus"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    {this.props.values.provider !== "PackagePickup" && <Fragment>
                        <div className="col-sm-2">
                            <Select
                                name="calculation_basis"
                                storeType="local"
                                optionname="commission_calculation_basis"
                                objectValue={false}
                                value={this.props.values.calculation_basis}
                                label="Számítás alapja"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("calculation_basis")}
                            />
                        </div>
                        <div className="col-sm-2">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="commission_value"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Jutalék mértéke"
                            />
                        </div>
                        <div className="col-sm-2">
                            <Select
                                name="commission_value_type"
                                storeType="local"
                                optionname="commission_value_type"
                                objectValue={false}
                                value={this.props.values.commission_value_type}
                                label="Jutalékszámítás"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("commission_value_type")}
                            />
                        </div>
                    </Fragment>}
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="vat"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Áfa"
                            storeType="local"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(CommissionForm);
